import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaskDirective } from './ng2-input-mask.module/mask.directive';
import { MaskService } from './ng2-input-mask.module/mask.service';

@NgModule({
  exports: [
    MaskDirective
  ],
  declarations: [
    MaskDirective
  ],
  providers: [
    MaskService
  ]
})
export class Ng2InputMaskModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/modules/ng2-input-mask.module.ts